<div *ngIf="quoteDetails?.id">
  <!-- Policy / Quote Information -->
  <h4><u>Policy / Quote Information</u></h4>
  <div class="row">
    <div class="col-md-8">
      <div class="row mb-3">
        <div class="col-md-4"><label>Quote Reference:</label></div>
        <div class="col-md-8"><input type="text" [value]="quoteDetails.quote_ref_number || '—'" class="form-control form-control-sm" readonly></div>
      </div>
    </div>
  </div>

  <!-- Cover Details -->
  <h4 class="mt-4"><u>Cover Details</u></h4>
  <div class="row">
    <div class="col-md-8">
      <div class="row mb-3">
        <div class="col-md-4"><label>Cover Type:</label></div>
        <div class="col-md-8"><input type="text" [value]="getCoverTypeName()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="quoteDetails.horse_class_id || quoteDetails.horse_class">
        <div class="col-md-4"><label>Class of Use:</label></div>
        <div class="col-md-8"><input type="text" [value]="quoteDetails.horse_class?.class_name || quoteDetails.horse_class_name || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="quoteDetails.horse_class_sub_id || quoteDetails.main_use_of_horse_id || quoteDetails.horse_class_id || quoteDetails.blood_stock_id">
        <div class="col-md-4"><label>Main Use of Horse:</label></div>
        <div class="col-md-8"><input type="text" [value]="mainUseOfHorseDisplay || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Loss of Horse:</label></div>
        <div class="col-md-8"><input type="text" [value]="getLossOfHorseDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Elective Surgery:</label></div>
        <div class="col-md-8"><input type="text" [value]="getElectiveSurgeryDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Disposal & Euthanasia:</label></div>
        <div class="col-md-8"><input type="text" [value]="getDisposalDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Permanent Loss of Use:</label></div>
        <div class="col-md-8"><input type="text" [value]="getPermanentLouDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="showLouActivityRow()">
        <div class="col-md-4"><label>LOU Activity:</label></div>
        <div class="col-md-8"><input type="text" [value]="getLouActivityName()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Vet Fee Cover Selected:</label></div>
        <div class="col-md-8"><input type="text" [value]="getVetFeeCoverSelectedDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div *ngIf="isStandardCover || isRestrictedCover || (isBloodstockCover && quoteDetails.is_vet_fee_selected == 1) || isACECover">
        <div class="row mb-3" *ngIf="quoteDetails.is_vet_fee_selected == 1 || isACECover">
          <div class="col-md-4"><label>Vet Fee Cover:</label></div>
          <div class="col-md-8"><input type="text" [value]="getVetFeeCoverDisplay()" class="form-control form-control-sm" readonly></div>
        </div>
        <div class="row mb-3" *ngIf="quoteDetails.is_vet_fee_selected == 1 || isACECover">
          <div class="col-md-4"><label>Vet Fee Excess:</label></div>
          <div class="col-md-8"><input type="text" [value]="getVetFeeExcessDisplay()" class="form-control form-control-sm" readonly></div>
        </div>
        <div class="row mb-3" *ngIf="!isBloodstockCover && !isACECover && quoteDetails.is_vet_fee_selected == 1">
          <div class="col-md-4"><label>Vet Fee Optional Co-Insurance:</label></div>
          <div class="col-md-8"><input type="text" [value]="getVetFeeCoInsuranceDisplay()" class="form-control form-control-sm" readonly></div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Hospitalisation & Transportation:</label></div>
        <div class="col-md-8"><input type="text" [value]="getHospitalisationDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Life-Saving Surgery Top-Up:</label></div>
        <div class="col-md-8"><input type="text" [value]="getLifeSavingSurgeryDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
    </div>
  </div>

  <!-- Horse Details (same fields and order as quote-details form) -->
  <h4 class="mt-4"><u>Horse Details</u></h4>
  <div class="row" *ngIf="quoteDetails.horse_details">
    <div class="col-md-8">
      <div class="row mb-3">
        <div class="col-md-4"><label>Stable Name <span class="text-danger">*</span>:</label></div>
        <div class="col-md-8"><input type="text" [value]="quoteDetails.horse_details.stable_name || quoteDetails.horse_details.name || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Passport Name <span class="text-danger">*</span>:</label></div>
        <div class="col-md-8"><input type="text" [value]="quoteDetails.horse_details.passport_name || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Acquired Date <span class="text-danger">*</span>:</label></div>
        <div class="col-md-8"><input type="text" [value]="(quoteDetails.horse_details.horse_purchase_date || quoteDetails.horse_details.acquired_date) | date:'dd/MM/yyyy'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Ownership Status:</label></div>
        <div class="col-md-8"><input type="text" [value]="getOwnershipStatusName(quoteDetails.horse_details.ownership_status_id || quoteDetails.horse_details.ownership_status?.id || quoteDetails.horse_details.ownership_status) || quoteDetails.horse_details.ownership_status?.status_name || quoteDetails.horse_details.ownership_status_name || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Purchase Price:</label></div>
        <div class="col-md-8"><input type="text" [value]="(quoteDetails.horse_details.purchase_price != null && quoteDetails.horse_details.purchase_price !== '') ? (quoteDetails.horse_details.purchase_price | number:'1.2-2') : '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Sum Insured <span class="text-danger">*</span>:</label></div>
        <div class="col-md-8"><input type="text" [value]="getSumInsuredDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Year of Birth:</label></div>
        <div class="col-md-8"><input type="text" [value]="(+quoteDetails.horse_details.horse_birth_year > 0 ? quoteDetails.horse_details.horse_birth_year : (quoteDetails.horse_details.birth_year || '—'))" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Age:</label></div>
        <div class="col-md-8"><input type="text" [value]="getAgeDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <!-- Additional horse fields (same as quote-details extras) -->
      <div class="row mb-3">
        <div class="col-md-4"><label>Sex:</label></div>
        <div class="col-md-8"><input type="text" [value]="getGenderName() || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Height (Hands):</label></div>
        <div class="col-md-8"><input type="text" [value]="(quoteDetails.horse_details.height && quoteDetails.horse_details.height !== '0.0') ? quoteDetails.horse_details.height : '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Passport Number:</label></div>
        <div class="col-md-8"><input type="text" [value]="quoteDetails.horse_details.passport || quoteDetails.horse_details.passport_number || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Breed:</label></div>
        <div class="col-md-8"><input type="text" [value]="getBreedName(quoteDetails.horse_details.breed_id) || quoteDetails.horse_details.breed_name || quoteDetails.horse_details.horse_breed?.breed || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Colour:</label></div>
        <div class="col-md-8"><input type="text" [value]="getColorName(quoteDetails.horse_details.color_id) || quoteDetails.horse_details.color_name || quoteDetails.horse_details.horse_color?.color || '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Horse Vetted:</label></div>
        <div class="col-md-8"><input type="text" [value]="getIsHorseVettedDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="quoteDetails.horse_details.is_horse_vetted === 2 && quoteDetails.horse_details.date_of_vetting">
        <div class="col-md-4"><label>Date of Vetting:</label></div>
        <div class="col-md-8"><input type="text" [value]="(quoteDetails.horse_details.date_of_vetting != null && quoteDetails.horse_details.date_of_vetting !== '') ? (quoteDetails.horse_details.date_of_vetting | date:'dd/MM/yyyy') : '—'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="quoteDetails.horse_details.is_insured_by_you != null">
        <div class="col-md-4"><label>Currently Insured:</label></div>
        <div class="col-md-8"><input type="text" [value]="getCurrentlyInsuredDisplay()" class="form-control form-control-sm" readonly></div>
      </div>
    </div>
  </div>

  <!-- Claims History -->
  <h4 class="mt-4"><u>Claims History</u></h4>
  <div class="row">
    <div class="col-md-12">
      <div class="row mb-3">
        <div class="col-md-4"><label>Claims for proposed horse (last 3 years):</label></div>
        <div class="col-md-8"><input type="text" [value]="proposedHorseClaims.length > 0 ? 'Yes' : 'No'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="proposedHorseClaims.length > 0">
        <div class="col-md-12">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Claim Type</th>
                <th>Cause</th>
                <th>Status</th>
                <th>Settlement Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of proposedHorseClaims">
                <td>{{ c.claim_date | date:'dd/MM/yyyy' }}</td>
                <td>{{ getClaimTypeName(c) }}</td>
                <td>{{ c.claim_cause || '—' }}</td>
                <td>{{ getClaimStatusLabel(c.claim_status) }}</td>
                <td>{{ c.settlement_amount != null ? (c.settlement_amount | number:'1.2-2') : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><label>Claims for other horses (last 3 years):</label></div>
        <div class="col-md-8"><input type="text" [value]="otherHorsesClaimsList.length > 0 ? 'Yes' : 'No'" class="form-control form-control-sm" readonly></div>
      </div>
      <div class="row mb-3" *ngIf="otherHorsesClaimsList.length > 0">
        <div class="col-md-12">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Claim Type</th>
                <th>Cause</th>
                <th>Status</th>
                <th>Settlement Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of otherHorsesClaimsList">
                <td>{{ c.claim_date | date:'dd/MM/yyyy' }}</td>
                <td>{{ getClaimTypeName(c) }}</td>
                <td>{{ c.claim_cause || '—' }}</td>
                <td>{{ getClaimStatusLabel(c.claim_status) }}</td>
                <td>{{ c.settlement_amount != null ? (c.settlement_amount | number:'1.2-2') : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Statement of Facts -->
  <h4 class="mt-4"><u>Statement of Facts</u></h4>

  <div *ngIf="generalSofList.length > 0" class="mb-3">
    <h5 class="mt-3 mb-2">General Statement of Facts</h5>
    <div class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th style="width: 60%">Statement</th>
            <th>Response</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sof of generalSofList">
            <td>{{ getStatementOfFactDescription(sof) }}</td>
            <td>{{ getStatementOfFactResponse(sof) }}<span *ngIf="sof.response_text"> – {{ sof.response_text }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="veterinarySofList.length > 0" class="mb-3">
    <h5 class="mt-3 mb-2">Veterinary Statement of Facts</h5>
    <div class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th style="width: 60%">Statement</th>
            <th>Response</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sof of veterinarySofList">
            <td>{{ getStatementOfFactDescription(sof) }}</td>
            <td>{{ getStatementOfFactResponse(sof) }}<span *ngIf="sof.response_text"> – {{ sof.response_text }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="declarationSofList.length > 0" class="mb-3">
    <h5 class="mt-3 mb-2">Declaration Statement of Facts</h5>
    <div class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th style="width: 60%">Statement</th>
            <th>Response</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sof of declarationSofList">
            <td>{{ getStatementOfFactDescription(sof) }}</td>
            <td>{{ getStatementOfFactResponse(sof) }}<span *ngIf="sof.response_text"> – {{ sof.response_text }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row mb-3" *ngIf="!generalSofList.length && !veterinarySofList.length && !declarationSofList.length">
    <div class="col-md-12"><p class="text-muted mb-0">No statement of facts recorded.</p></div>
  </div>

  <!-- Endorsements -->
  <app-quote-endorsement [quote]="endorsementQuote" [isEquine]="true"></app-quote-endorsement>
</div>
<p *ngIf="!quoteDetails?.id" class="text-muted">No quote data.</p>
